const BASE_URL = window._env_.REACT_APP_BROKER_API_URL.replace("/events", "");

const mockData = {
    "reconciledEntryHeader": {
        "actionCode": "A",
        "filerCode": "S1F",
        "entryNumber": "55691661",
        "processingPort": "2809",
        "brokerReferenceNumber": "123456",
        "electronicSignature": "X",
        "importerOfRecordNumber": "58-123456789",
        "notifyPartyNumber": "58-123456789",
        "suretyCompanyCode": "981",
        "reconciliationTypeCode": "CE1",
        "importEntryLocationCode": "US",
        "priorDisclosureIndicator": "Y",
        "aggrigateRefundWaiverIndicator": "Y",
        "shippingId": "KX-BASF-3340",
        "contactName": "Chris Wood",
        "contactPhoneNumber": "111-111-1111",
        "contactEmailAddress": "chris.wood@klearnow.com",
        "reconShipmentId": 2,
        "importerName": "BASF AP",
        "createdByBrokerId": "123456",
        "payableAmountGrnadTotalDetails": [
            {
                "revenueId": 10,
                "accountingClassName": "DUTY",
                "revenueAmount": 123.18,
                "revenueType": "RECON_SHIPMENT_PAYABLE_AMOUNT_REVENUE",
                "parentItemId": 2
            },
            {
                "revenueId": 11,
                "accountingClassName": "HARBOR MAINTENANCE FEE",
                "revenueAmount": 45.37,
                "revenueType": "RECON_SHIPMENT_PAYABLE_AMOUNT_REVENUE",
                "parentItemId": 2
            }
        ]
      },
        "reconciledEntrySummaries": {
            "testEntrySummaryID1": {
                "orgFillerCode": "T2E",
                "orgEntryNumber": "678912",
                "orgShipmentId": "KX-I5H7-5678",
                "orgRevenueDetails": [
                    {
                        "revenueId": 10,
                        "accountingClassName": "DUTY",
                        "revenueAmount": 123.18,
                        "revenueType": "RECONCILED_ENTRY_ORG_REVENUE",
                        "parentItemId": 1
                    },
                    {
                        "revenueId": 11,
                        "accountingClassName": "HARBOR MAINTENANCE FEE",
                        "revenueAmount": 45.37,
                        "revenueType": "RECONCILED_ENTRY_ORG_REVENUE",
                        "parentItemId": 1
                    }
                ],
              "lineItemList": ["TESTLINE1", "TESTLINE2", "TESTLINE3"],
               "reconShipmentId": 2
            }
        },
        
        "lineItems": {
            "TESTLINE1": {
                "lineId": "TESTLINE1",
                "reconciledEntryId": "testEntrySummaryID1",
                "orgHTSNumber": "2203000031",
                "orgSpecialProgramClaimCode": "TEST-U",
                "orgBeginEffectiveDate": 1608941352000,
                "orgMerchValue": 4123.12,
                "orgMerchDuty": 1212.12,
                "lineNumber": "001",
                "reconHTSNumber": "2203000031",
                "reconMerchValue": 2878.98,
                "reconMerchDuty": 350.23,
                "countryOfOrigin": "US",
                "reconSpecialProgramClaimCode": "TEST2U",
                "reconEntryId": 1,
                "orgRevenueDetails": [
                    {
                        "revenueId": 4,
                        "accountingClassName": "DUTY",
                        "revenueAmount": 123.18,
                        "revenueType": "LINE_ITEM_ORG_REVENUE",
                        "parentItemId": 1
                    },
                    {
                        "revenueId": 2,
                        "accountingClassName": "HARBOR MAINTENANCE FEE",
                        "revenueAmount": 45.37,
                        "revenueType": "LINE_ITEM_ORG_REVENUE",
                        "parentItemId": 1
                    }
                ],
                "reconRevenueDetails": [
                    {
                        "revenueId": 4,
                        "accountingClassName": "DUTY",
                        "revenueAmount": 123.18,
                        "revenueType": "LINE_ITEM_RECON_REVENUE"
                    },
                    {
                        "revenueId": 2,
                        "accountingClassName": "HARBOR MAINTENANCE FEE",
                        "revenueAmount": 45.37,
                        "revenueType": "LINE_ITEM_RECON_REVENUE"
                    }
                ]
            }
        }
}

export {
    BASE_URL,
    mockData
}